(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-facets"] && !Shopify.designMode) return;
  try {
    (function () {
  var form = document.getElementById('FacetFiltersFormMobile');
  if (!form) return;

  function handleShowMore(trigger) {
    var parent = trigger.closest('.parent-display');
    if (!parent) return;
    trigger.querySelectorAll('.label-text').forEach(function (el) {
      el.classList.toggle('hidden');
    });
    parent.querySelectorAll('.show-more-item').forEach(function (item) {
      item.classList.toggle('hidden');
    });
  }

  form.addEventListener('click', function (event) {
    var trigger = event.target.closest('.custom-show-more .button-show-more');
    if (trigger) handleShowMore(trigger);
  });

  form.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = event.target.closest('.custom-show-more .button-show-more');
    if (!trigger) return;
    event.preventDefault();
    handleShowMore(trigger);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-review-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
  var timers = {};

  function cardWidth(track) {
    var card = track.querySelector('.review-carousel__card');
    return card ? card.offsetWidth : 0;
  }

  function scrollCarousel(track, direction) {
    var w = cardWidth(track);
    if (!w) return;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    var atStart = track.scrollLeft <= 1;
    if (direction > 0 && atEnd) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (direction < 0 && atStart) {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: direction * w, behavior: 'smooth' });
    }
  }

  function startAutoplay(el) {
    var delay = parseInt(el.getAttribute('data-rc-autoplay'), 10);
    if (!delay) return;
    clearInterval(timers[el.id]);
    timers[el.id] = setInterval(function() {
      var track = document.getElementById(el.id + '-track');
      if (track) scrollCarousel(track, 1);
    }, delay);
  }

  function stopAutoplay(el) {
    clearInterval(timers[el.id]);
  }

  function carouselForDialog(dialog) {
    return dialog.closest('[data-rc-autoplay]');
  }

  function initCarousels() {
    document.querySelectorAll('[data-rc-autoplay]').forEach(function(el) {
      if (!parseInt(el.getAttribute('data-rc-autoplay'), 10)) return;
      startAutoplay(el);
      el.addEventListener('mouseenter', function() { stopAutoplay(el); });
      el.addEventListener('mouseleave', function() { startAutoplay(el); });
      el.addEventListener('touchstart', function() { stopAutoplay(el); }, { passive: true });
      el.addEventListener('touchend', function() {
        setTimeout(function() { startAutoplay(el); }, 1200);
      }, { passive: true });

      el.querySelectorAll('.review-carousel__body-wrap').forEach(function(wrap) {
        var body = wrap.querySelector('.review-carousel__body');
        var btn = wrap.querySelector('.review-carousel__read-more');
        if (body && body.scrollHeight <= wrap.clientHeight + 2) {
          wrap.classList.add('review-carousel__body-wrap--unclamped');
          if (btn) btn.style.display = 'none';
        }
      });

      el.querySelectorAll('.review-carousel__dialog').forEach(function(dialog) {
        var carousel = carouselForDialog(dialog);
        dialog.addEventListener('close', function() {
          if (carousel) startAutoplay(carousel);
        });
        dialog.addEventListener('click', function(e) {
          if (e.target === dialog) dialog.close();
        });
      });
    });
  }

  document.addEventListener('click', function(e) {
    var navBtn = e.target.closest('[data-rc-prev], [data-rc-next]');
    if (navBtn) {
      var isPrev = navBtn.hasAttribute('data-rc-prev');
      var rcId = isPrev ? navBtn.getAttribute('data-rc-prev') : navBtn.getAttribute('data-rc-next');
      var track = document.getElementById(rcId + '-track');
      if (track) scrollCarousel(track, isPrev ? -1 : 1);
      var el = document.getElementById(rcId);
      if (el) { stopAutoplay(el); startAutoplay(el); }
      return;
    }

    var opener = e.target.closest('[data-rc-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-rc-open'));
      if (dialog) {
        var carousel = carouselForDialog(dialog);
        if (carousel) stopAutoplay(carousel);
        dialog.showModal();
      }
      return;
    }

    var closeBtn = e.target.closest('[data-rc-close]');
    if (closeBtn) {
      var dlg = closeBtn.closest('dialog');
      if (dlg) dlg.close();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
